import styled from "styled-components";

export const SportsFilterContentWrapper = styled.div``;
